module.exports = __webpack_public_path__ + "img/00047.4639f65d.webp";